<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="svgWidth()"
  [attr.height]="size()"
  [attr.viewBox]="'0 0 ' + viewBoxWidth() + ' 24'"
  aria-label="MI badge icon"
  role="img">
  @if (tooltip()) {
    <title>{{ tooltip() }}</title>
  }

  @if (shape() === Shape.Hexagon) {
    <polygon
      [attr.points]="hexagonPoints()"
      [attr.fill]="resolvedBackgroundColor()"
      [attr.stroke]="mainStroke()"
      stroke-width="1.5" />
  } @else if (shape() === Shape.Shield) {
    <path
      [attr.d]="shieldPath()"
      [attr.fill]="resolvedBackgroundColor()"
      [attr.stroke]="mainStroke()"
      stroke-width="1.5"
      stroke-linejoin="round" />
    <path
      [attr.d]="shieldLeftFacetPath()"
      [attr.fill]="resolvedBackgroundColor()"
      stroke="none" />
    <path
      [attr.d]="shieldRightFacetPath()"
      fill="rgba(255,255,255,0.28)"
      stroke="none" />
    <path
      [attr.d]="shieldRidgePath()"
      fill="none"
      stroke="rgba(255,255,255,0.25)"
      stroke-width="0.7"
      stroke-linecap="round" />
    <path
      [attr.d]="shieldTopHighlightPath()"
      fill="none"
      stroke="rgba(255,255,255,0.60)"
      stroke-width="0.9"
      stroke-linecap="round" />
  } @else {
    <circle
      cx="12"
      cy="12"
      r="10"
      [attr.fill]="resolvedBackgroundColor()"
      [attr.stroke]="mainStroke()"
      stroke-width="1.5" />
  }

  <text
    [attr.x]="centerX()"
    [attr.y]="shape() === Shape.Shield ? 12 : 13.6"
    text-anchor="middle"
    dominant-baseline="middle"
    font-family="Helvetica Neue, Helvetica, Arial, sans-serif"
    font-size="11.5"
    font-weight="700"
    fill="var(--badge-text-color)"
    letter-spacing="0.3">
    {{ safeLabel() }}
  </text>

  @if (shape() === Shape.Circle) {
    @switch (badge()) {
      @case ('check') {
        <circle cx="17.8" cy="7.4" r="5.4" fill="var(--badge-check-fill)" />
        <path
          d="M15.8 7.6 L17.4 9.2 L20.4 6.0"
          fill="none"
          stroke="var(--badge-contrast-color)"
          stroke-width="2.4"
          stroke-linecap="round"
          stroke-linejoin="round" />
      }

      @case ('warning') {
        <path d="M17.8 0.8 L23.1 10.5 L12.5 10.5 Z" fill="var(--badge-warning-fill)" />
        <path
          d="M17.8 4.0 L17.8 7.0"
          fill="none"
          stroke="var(--badge-contrast-color)"
          stroke-width="1.6"
          stroke-linecap="round" />
        <circle cx="17.8" cy="8.8" r="0.6" fill="var(--badge-contrast-color)" />
      }

      @default {
        <!-- no badge -->
      }
    }
  }
</svg>